"use client";

import dynamic from "next/dynamic";

const AboutSectionOne = dynamic(() => import("./AboutSectionOne"), { ssr: false, });
const AboutSectionTwo = dynamic(() => import("./AboutSectionTwo"), { ssr: false, });

export default function AboutSection() {
  return (
    <>
      <AboutSectionOne />
      <AboutSectionTwo />
    </>
  );
}
